import { DatePipe } from "@angular/common";
import { Injectable } from "@angular/core";
import { ApiService } from "src/app/components/shared/api.service";
import { localStorageService } from "src/app/components/shared/localstorage.service";
import { SharedService } from "src/app/components/shared/shared.service";

@Injectable()
export class AssignmentsService {
    public filter: any = {
        start_date: new Date('2024/01/01'),
        end_date: new Date(),
        is_expired: -1,
        status_filter: 0,
        ProposalType: 0// filter for AR 
    };
    dateRangeValue: any;
    public resData: any = {
        pageNumber: 1
    };
    public sortValue: { by: string, order: string, label: string } = {
        by: 'date_added',
        order: 'DESC',
        label: 'Registration Date'
    };
    public modalTypes = {
      assignToMeModal: 'assignToMeModal',
      deleteModal: 'deleteModal',
      ticketAssignToMeModal: 'ticketAssignToMeModal',
      approveRejectModal: 'approveRejectModal',
      changeStatusModal: 'changeStatusModal',
      addNoteModal: 'addNoteModal',
      updateInformationInquiryModal: 'updateInformationInquiryModal',
      viewDocuments: "viewDocuments",
      viewFullSSN:'viewFullSSN',
      businessDocs:"businessDocs",
    }
    public country_id: any = this._local.customGetItem('country_id');

    total_balance_remaining: number = 0;
    timezone: string = '';
    timezoneName: string = '';
    remaining_amount_with_def: number = 0;
    remaining_amount_after_def: number = 0;
    def_duration: number = 0;
    total_balance_remaining_after_def: number = 0;

    totalCustomArrangementPayable: any;
    totalRecurringAmount: any;
    currentYear = new Date().getFullYear();
    currentMonth = new Date().getMonth() + 1;
    constructor (private _local: localStorageService, public _shared: SharedService) {
        this.timezoneName = this._shared.getTimezoneName();
        this.timezone = this._shared.getTimezone();
    }
}